import { FC } from 'react'
import { Figcaption, StyledVideo, WideImage } from './styled'
import { TextContainer } from 'components/container'

export const VideoLoop: FC<{ url: string; description?: string }> = ({
  url,
  description,
}) => (
  <WideImage>
    <StyledVideo autoPlay muted playsInline loop>
      <source type="video/mp4" src={url} />
    </StyledVideo>
    <Figcaption>
      {!!description && <TextContainer>{description}</TextContainer>}
    </Figcaption>
  </WideImage>
)
